module.exports = __webpack_public_path__ + "img/2012-09-06 (FF 15) Montage Holzelemente.cbaa79a5.jpg";